var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAIIconBtn',_vm._g(_vm._b({class:{ 'q-mr-md': _vm.spaced },attrs:{"icon":"eva-arrow-back","color":"grey-8","size":"12px"}},'SAIIconBtn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }